import React from "react";
import {Box} from "@mui/material";
import Search from "./Search";
import GenreFilter from "./GenreFilter";
import PlatformFilter from "./PlatformFilter";

import {useSelector, useDispatch}  from "react-redux";

function Filters(){

	const genreList = useSelector((state)=>state.API.genres);
	const platformList = useSelector((state)=>state.API.platform);

	return (
		<Box className="filter_class">
			<Search />
			<GenreFilter data={genreList} label="Select the Genre" fid={1}/>
			<PlatformFilter data={platformList} label="Select the Platform" fid={2} />
		</Box>
	);
}

export default Filters;